import script from "./ClassicAuthCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicAuthCard.vue?vue&type=script&setup=true&lang=js"

import "./ClassicAuthCard.vue?vue&type=style&index=0&id=369f9048&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369f9048"]])

export default __exports__